
import About from './About';
import './App.css';
import Blog from './Blog';
import Contact from './Contact';
import Footer from './Footer';
/*import Body from './components/Body'; */
/*import Open from './components/Open'; */
import Home from './Home';
import Project from './Project';
import Service from './Service';


function App() {
  return (
    <div>
     <Home /> 
     <About />
     <Service />
     <Project />
     <Blog />
     <Contact />
     <Footer />
   {/* <Open /> */}
   {/* <Body /> */}
   
      

    </div>
  );
}

export default App;
